import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import messages from './local/index';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: ['en', 'es'],
    // Allow 'es-US', 'es-419' etc. to match 'es'
    nonExplicitSupportedLngs: true,
    // Strip region codes — always use 'en' not 'en-US'
    load: 'languageOnly',
    debug: false,
    resources: messages,
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
      // Also strip region codes from detected language
      convertDetectedLanguage: (lng: string) => lng.split('-')[0],
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
